/**
 * vuex状态管理
 */
import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import user from './modules/user';
import theme from './modules/theme';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    lang: localStorage.getItem('hippoLang') ? localStorage.getItem('hippoLang'): (process.env.VUE_APP_THEME == 'hippo' ? 'en' : 'zh'),
  },
  mutations: {
    SET_LANGUAGE(state, lang) {
      state.lang = lang;
      localStorage.setItem('hippoLang', lang); // 本地化
    }
  },
  actions: {},
  modules: {
    user,
    theme
  },
  getters
});
